import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-account-container menu-list" }
const _hoisted_2 = { class: "navbar-item has-dropdown is-hoverable" }
const _hoisted_3 = { class: "navbar-link is-arrowless" }
const _hoisted_4 = { class: "navbar-dropdown is-boxed" }
const _hoisted_5 = {
  key: 0,
  class: "workspace-scroll-container"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "icon is-small"
}
const _hoisted_8 = { class: "dropdown-footer" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { CHANGE_WORKSPACE } from '@/store/app/actionTypes';
import { useAuth } from '@/authentication/useAuth';

// Vuex store

export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsNavMenu',
  setup(__props) {

const store = useStore();

// Router and Route
const router = useRouter();
const { logout, isPlatformAdmin } = useAuth();

// Computed properties (Vuex getters)
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const workspaces = computed(() => store.getters.workspaces);

function selectWorkspace(workspace: WorkspaceViewModel) {
  store.dispatch(CHANGE_WORKSPACE, workspace); // Fixed from store.actions
}

function goToSettings() {
  router.push({ name: 'general-settings' });
}

function goToPlatformAdmin() {
  router.push({ name: 'platform-admin-workspaces-list' });
}

function goToRoot() {
  router.push({ name: 'root' });
}

const route = useRoute();
const activeRouteName = computed(() => String(route?.name || ''));
const isPlatformAdminRoute = computed(() => activeRouteName.value.startsWith('platform-admin'));

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, { icon: "cog" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(isPlatformAdmin) || !isPlatformAdminRoute.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (workspace) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "navbar-item",
                  key: workspace.id,
                  onClick: ($event: any) => (selectWorkspace(workspace))
                }, [
                  _createElementVNode("span", null, _toDisplayString(workspace.name), 1),
                  (workspace.id === currentWorkspace.value.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createVNode(_component_font_awesome_icon, { icon: "check" })
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_6))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (_unref(isPlatformAdmin) && !isPlatformAdminRoute.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "navbar-item",
                onClick: goToPlatformAdmin
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "Switch to Platform Admin", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_unref(isPlatformAdmin) && isPlatformAdminRoute.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "navbar-item",
                onClick: goToRoot
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", null, "Exit Platform Admin", -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_unref(isPlatformAdmin) || !isPlatformAdminRoute.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "navbar-item",
                onClick: goToSettings
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", null, "Manage Workspace Settings", -1)
              ]))]))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "navbar-divider" }, null, -1)),
          _createElementVNode("a", {
            class: "navbar-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(logout) && _unref(logout)(...args)))
          }, " Logout ")
        ])
      ])
    ])
  ]))
}
}

})